module.exports = __webpack_public_path__ + "img/client-5.658bcdc1.png";